import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageBanner from "../components/PageBanner";
import Reveal from "../components/Reveal";
import { blogPosts } from "../mock";

const BlogPage = () => {
  return (
    <>
      <PageBanner
        title="Insights"
        subtitle="Perspectives, guides and lessons on cross-border business, market entry and global expansion."
        crumbs={[{ label: "Insights" }]}
      />
      <section className="bg-white py-20 md:py-24">
        <div className="mx-auto max-w-7xl px-4 md:px-8">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {blogPosts.map((post, i) => (
              <Reveal key={post.id} delay={i * 100}>
                <Link
                  to={`/blog/${post.id}`}
                  className="group flex h-full flex-col overflow-hidden rounded-2xl bg-white shadow-[0_10px_40px_-24px_rgba(15,42,74,0.35)] transition-shadow duration-300 hover:shadow-[0_24px_60px_-28px_rgba(15,42,74,0.45)]"
                >
                  <div className="h-52 overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-6">
                    <div className="mb-3 flex items-center gap-3 text-xs">
                      <span className="font-semibold uppercase tracking-[0.14em] text-[#E4545F]">
                        {post.category}
                      </span>
                      <span className="text-slate-400">{post.date}</span>
                    </div>
                    <h3 className="text-lg font-semibold leading-snug text-[#0F2A4A] transition-colors duration-200 group-hover:text-[#E4545F]">
                      {post.title}
                    </h3>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">
                      {post.excerpt}
                    </p>
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-[#0F2A4A] transition-all duration-200 group-hover:gap-3">
                      Read more <ArrowRight className="h-4 w-4" />
                    </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
